import { getFeatureFlagsProperties } from '@pflegia/feature-flags/utils/helpers/get-feature-flag-properties';
import { FunnelQuestionCategory } from '@pflegia/types/api/funnel/questions';
import { SegmentTrackingEventName } from '@pflegia/types/common/enums';
import { isDefined } from '@pflegia/util/functions/type-guards';

import useRegisterMethod from '@shared/hooks/use-register-method';

import { accessTokenService } from '@utils/access-token.service';

import { segmentService } from './analytics/segment.service';
import { RegisterButtonTrackingIds, signupButtonClickTrackEventRegistration } from './marketing/events/register-button';
import { TrackingEventName } from './marketing/events/tracking-event-name';
import { trackEventRegistration } from './tracking/track-registration';

type TrackingFunction = (eventName: TrackingEventName | string | SegmentTrackingEventName, data?: Record<string, unknown>) => void;

/*
  Track an event with the given name and data.
  The data is a key-value pair of strings.
*/
export const trackEvent: TrackingFunction = (eventName, data) => {
  const decodedToken = accessTokenService.getDecodedToken();
  segmentService.trackEvent({
    eventName,
    data: {
      ...data,
      ...getFeatureFlagsProperties(),
      label: eventName,
      category: eventName,
      userId: isDefined(decodedToken) ? decodedToken.sub : '',
    },
    withIntegrations: true,
  });
};

export const useTracking = () => {
  const { registerMethod } = useRegisterMethod();

  return {
    track: trackEvent,
    trackEventRegistration: (
      eventName: string,
      eventProperties?: Record<string, unknown>,
      questionId?: string,
      questionCategory?: FunnelQuestionCategory,
    ) => trackEventRegistration(eventName, registerMethod, eventProperties, questionId, questionCategory),

    signupButtonClickTrackEventRegistration: (buttonId: RegisterButtonTrackingIds, sortedBy?: string) =>
      signupButtonClickTrackEventRegistration(buttonId, registerMethod, sortedBy),
    resetAnalyticsIdentity: segmentService.resetID,
  };
};
